// RBAC core client (docs/DECISIONS.md, "RUDVAN Admin Module: internal
// staff, RBAC, student-mentor allocation") - GET /api/admin/me returns the
// current staff member's resolved permission set so the frontend can hide
// (not just have the backend reject) functionality the user can't use
// (FR-ADM-10), mirroring adminStudents.js's call/readErrorDetail pattern.

import { apiFetch, ADMIN_SERVICE_ORIGIN } from './api';
import { readErrorDetail } from '../components/Admin/adminShared';

async function call(path, options, fallbackError) {
  const response = await apiFetch(path, options, ADMIN_SERVICE_ORIGIN);
  if (!response.ok) throw new Error(await readErrorDetail(response, fallbackError));
  return response.json();
}

export async function adminGetMyAccess() {
  return call('/api/admin/me', {}, 'Failed to load access.');
}

export async function adminListPermissionCatalog() {
  return (await call('/api/admin/permissions', {}, 'Failed to load permission catalog.')).modules;
}

export function hasPermission(access, key) {
  if (!access) return false;
  return access.is_superadmin || (access.permissions || []).includes(key);
}
